<template>
    <div class="">
        <div class="container">
            <h2>100T+ Banknotes Lookup</h2>
            <div class="">
                <p>
                    Enter a banknote's <span class="link">Authentication Number</span> below to verify authenticity and
                    banknote ownership in 100T's database.
                </p>
            </div>
        </div>
        <div class="container">
            <div>
                <b-overlay
                    :show="verifying"
                    spinner-variant="primary"
                    blur=".3"
                    opacity=".75"
                    rounded="sm"
                    class="">
                    <validation-observer ref="LookupForm">
                        <b-form @submit.prevent="onSubmit"
                                class="d-flex justify-content-between gap-10 align-items-center auth-form">
                            <validation-provider
                                #default="{ errors }"
                                name="Authentication"
                                rules="required"
                                class="w-100"
                            >
                                <b-form-group
                                    label="Authentication #:"
                                    label-for="auth_input"
                                >
                                    <b-form-input
                                        id="auth_input"
                                        v-model="authInput"
                                        class="input-style"
                                        :state="errors.length > 0 ? false : null"
                                        placeholder=""
                                    />
                                    <small class="text-danger position-absolute">{{ errors[0] }}</small>
                                </b-form-group>
                            </validation-provider>
                            <div class="">
                                <b-button type="submit" style="margin-top: 10px;" variant="primary" class="text-nowrap">
                                    Verify
                                    Note
                                </b-button>
                            </div>
                        </b-form>
                    </validation-observer>
                </b-overlay>
            </div>
            <div class="">
<!--                <b-button-->
<!--                    @click="seeAll"-->
<!--                    variant="outline-primary"-->
<!--                    class="">-->
<!--                    <span>See All My Tap</span>-->
<!--                </b-button>-->
            </div>
            <div v-if="tapData" class=" mt-4 row">
                <div v-if="tapData.media.length" class="image-div col-md-4 ">
                    <img :src="tapData.media[0].original_url" alt="" class="w-100 mb-3">
                </div>
                <div class="d-flex flex-column flex-wrap col-md-8">
                    <div class="item">
                        <label>Banknote Owner</label>
                        <span class="text-muted">{{ tapData.owner_name }}</span>
                    </div>
                    <div class="item">
                        <label>Serial Number</label>
                        <span class="text-muted">{{ tapData.serial_number }}</span>
                    </div>
                    <div class="item">
                        <label>Registered On</label>
                        <span class="text-muted">{{ tapData.registered_on ? tapData.registered_on : '-' }}</span>
                    </div>
                    <div class="item">
                        <label>Location</label>
                        <span class="text-muted">{{ tapData.location ? tapData.location.name : '-' }}</span>
                    </div>
                    <div class="item">
                        <label>Denomination</label>
                        <span
                            class="text-muted">{{ tapData.product.denomination ? tapData.product.denomination.name : '-' }}</span>
                    </div>
                    <div class="item">
                        <label>Year</label>
                        <span class="text-muted">{{ tapData.product.year }}</span>
                    </div>
                    <div class="item">
                        <label>Verified Security Features</label>
                        <div class="text-muted" v-if="tapData.product.verified_security_feature">
                            <div v-for="(feature, index) in formattedSecurityFeatures" :key="index">
                                {{ feature }}
                            </div>
                        </div>
                        <span class="text-muted" v-else>-</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "Lookup",
    props: {
      auth_number: ''
    },
    data() {
        return {
            authInput: '',
            verifying: false,
            tapData: null
        }
    },
    computed: {
        formattedSecurityFeatures() {
            if (!this.tapData || !this.tapData.product.verified_security_feature) {
                return [];
            }
            return this.tapData.product.verified_security_feature
                .split('\n')
                .map(feature => feature.trim())
                .filter(feature => feature.length > 0);
        }
    },
  mounted() {
      if(this.auth_number) {
        this.authInput = this.auth_number
        this.getTap()
      }
  },
  methods: {
        onSubmit() {
            this.$refs.LookupForm.validate().then(success => {
                if (success) {
                    this.getTap()
                }
            })
        },
        getTap() {
          this.verifying = true
          $.ajax({
            method: "GET",
            url: 'get_tap/' + this.authInput,
          })
            .then(res => {
              this.$successNotify(res.message)
              this.tapData = res.data
            })
            .catch((xhr) => {
              this.$errorNotify(xhr.responseJSON.message)
            })
            .always(() => {
              this.verifying = false;
            });
        },
    }
}
</script>

<style scoped lang="scss">
h2 {
    font-size: 1.75rem;
    color: #DEAA5E;
    margin-bottom: 1.75rem;
    margin-top: 2.1rem;
    font-weight: 700;
}

.gap-20 {
    gap: 20px;
}

p, p span {
    font-size: 1rem;
    line-height: 2.4rem;
}

span.link {
    color: #DEAA5E;
    text-decoration: underline;
}

.auth-form {
    width: 75%;
}

.tap-info {
    max-height: 26rem;

    .image-div img {
        width: 26rem;
    }

    .item {
        display: flex;
        flex-direction: column;
        margin-bottom: 1rem;
        margin-right: 2rem;

        label {
            font-size: 1rem;
            font-weight: 700;
        }

        span {
            font-size: 0.875rem;
        }
    }
}

@media (max-width: 768px) {
    .tap-info {
        max-height: unset;
    }
}

@media (max-width: 576px) {
    .auth-form {
        width: 100%;
    }
    .tap-info {
        flex-direction: column;

        .image-div img {
            width: 100%;
        }
    }
}
</style>
